var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomemin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e0e2e2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12a1 1 0 00-1 1v7h-2v-4a1 1 0 00-1-1h-4a1 1 0 00-1 1v4H7v-7a1 1 0 00-1-1h-.59L12 5.41 18.59 12zm-2-6h1v1.59l-1-1zm5.71 6.29L19 9.59V5a1 1 0 00-1-1h-3a1 1 0 00-.93.66l-1.36-1.37a1 1 0 00-1.41 0l-9 9A1 1 0 003 14h2v6a2 2 0 002 2h2a2 2 0 002-2v-3h2v3a2 2 0 002 2h2a2 2 0 002-2v-6h2a1 1 0 00.71-1.71z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomemin);
export default __webpack_public_path__ + "static/media/home.min.3332547b65b4374f7b4d52ffa3eb918b.svg";
export { ForwardRef as ReactComponent };